import { canAccess } from '@/acl/roles';

const menuItems = [
  {
    url: '/',
    name: 'BrokingTools',
    slug: 'dashboard',
    tagColor: 'warning',
    iconType: 'fal',
    icon: 'file-alt',
    class: '',
  },
  {
    url: '/coverholder-suite',
    name: 'CoverholderSuite',
    slug: 'coverholder_suite',
    tagColor: 'warning',
    iconType: 'fal',
    icon: 'file-alt',
    class: '',
  },
  {
    url: '/notify-a-claim',
    name: 'ClaimNotificationForms',
    slug: 'notify_a_claim',
    tagColor: 'warning',
    iconType: 'fas',
    icon: 'exclamation-triangle',
    class: '',
  },
  {
    url: '/work-in-progress',
    name: 'WorkInProgress',
    slug: 'work_in_progress',
    tagColor: 'warning',
    iconType: 'fal',
    icon: 'tasks',
    class: '',
  },
  {
    url: 'https://fisg.co.uk/contact-list',
    name: 'Contacts',
    slug: 'external',
    i18n: 'Contacts',
    tagColor: 'warning',
    iconType: 'fal',
    icon: 'users',
    class: '',
    target: '_blank'
  },
  {
    url: '/request-quotation',
    name: 'RequestQuotation',
    slug: 'upload_quotation',
    i18n: 'RequestQuotation',
    tagColor: 'warning',
    iconType: 'fas',
    icon: 'arrow-alt-up',
    class: 'RequestQuotation',
  },
  {
    url: process.env.VUE_APP_LANDING_PAGE_URL,
    name: 'ReturnToFIDES',
    slug: 'external',
    i18n: 'ReturnToFIDES',
    tagColor: 'warning',
    iconType: 'fas',
    icon: 'arrow-alt-left',
    class: 'return-to-fides mb-4',
  },
];

const canAccessMenuItem = async (item) => {
  return await canAccess(item);
}

export const getMenuItems = async () => {
  const filteredMenuItems = [];

  for (const menuItem of menuItems) {
    if (menuItem === 'ReturnToFIDES') {
      return true;
    }

    if (await canAccessMenuItem(menuItem)) {
      filteredMenuItems.push(menuItem);
    }
  }

  return filteredMenuItems;
};
